import {
  TEntityResponse,
  TEntityListResponse,
  TCreateFlowReqBody,
  TFlowResBody,
  TFlowSummaryResBody,
  TUpdateFlowReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TFlowsClient = {
  create(body: TCreateFlowReqBody, dry: boolean): Promise<TEntityResponse<'flow', TFlowResBody> | undefined>;
  update(
    id: string,
    body: TUpdateFlowReqBody,
    dry: boolean
  ): Promise<TEntityResponse<'flow', TFlowResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'flow', TFlowResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'flow', TFlowSummaryResBody> | undefined>;
};

function FlowsClient(apiClient: TAPIClient): TFlowsClient {
  return {
    async create(body: TCreateFlowReqBody, _dry?: boolean): Promise<TEntityResponse<'flow', TFlowResBody> | undefined> {
      const data = await apiClient.post<TCreateFlowReqBody, TEntityResponse<'flow', TFlowResBody>>('/flows', body);

      if (data && data.type !== 'flow') {
        throw new Error('Invalid entity type received, expected: flow, received: ' + data.type);
      }

      return data;
    },

    async update(
      id: string,
      body: TUpdateFlowReqBody,
      _dry?: boolean
    ): Promise<TEntityResponse<'flow', TFlowResBody> | undefined> {
      const data = await apiClient.put<TUpdateFlowReqBody, TEntityResponse<'flow', TFlowResBody>>(`/flows/${id}`, body);

      if (data && data.type !== 'flow') {
        throw new Error('Invalid entity type received, expected: flow, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/flows/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'flow', TFlowResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'flow', TFlowResBody>>(`/flows/${id}`);

      if (data && data.type !== 'flow') {
        throw new Error('Invalid entity type received, expected: flow, received: ' + data.type);
      }

      return data;
    },

    async list(limit: number, page: number): Promise<TEntityListResponse<'flow', TFlowSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'flow', TFlowSummaryResBody>>(
        `/flows?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'flow') {
        throw new Error('Invalid entity type received, expected: flow, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TFlowsClient, FlowsClient };
